import Vue from "vue";
import Vuex from "vuex";
import persistedState from "vuex-persistedstate";
import getters from "./getters";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loginInfo: {
      customer_id: "",
      customer_userid: "",
      customer_code: "",
      username: "",
      password: "",
    },
    package: "",
    // 动态配置的文本
    configTextList: "",
  },
  mutations: {
    SET_STATE: (state, info) => {
      for (const [key, val] of Object.entries(info)) {
        state[key] = val;
      }
    },
    RESET_STATE: state => {
      let temp = Object.assign({}, state);
      state = temp;
    },
    setLoginUser(state, data) {
      state.loginInfo = data;
    },
    setReadjyagrt(state, data) {
      state.loginInfo.is_readjyagrt = data;
    },
    setUsername(state, data) {
      state.loginInfo.username = data;
    },
    setPassword(state, data) {
      state.loginInfo.password = data;
    },
    searchlistpage(state, data) {
      state.searchlistpage = data;
    },
    homelist(state, data) {
      state.homelist = data;
    },
    infolist(state, data) {
      state.infolist = data;
    },
    chooseid(state, data) {
      state.chooseid = data;
    },
    pageurl(state, data) {
      state.pageurl = data;
    },
    searchlist(state, data) {
      state.searchlist = data;
    },
    createdorderInFo(state, data) {
      state.createdorderInFo = data;
    },
    pubvalue(state, data) {
      state.pubvalue = data;
    },
    pubvalue1(state, data) {
      state.pubvalue1 = data;
    },
    spanIndex(state, data) {
      state.spanIndex = data;
    },
    packageVal(state, data) {
      state.packageVal = data;
    },
    orderInvoice(state, data) {
      state.orderInvoice = data;
    },
    addobj(state, data) {
      state.addobj = data;
    },
    showerror(state, data) {
      state.showerror = data;
    },
    saveaddresstxt(state, data) {
      state.saveaddresstxt = data;
    },
    dingdanxianqing(state, data) {
      state.dingdanxianqing = data;
    },
    morendizhi(state, data) {
      state.morendizhi = data;
    },
    setUser(state, data) {
      state.user = data;
    },
  },
  actions: {},
  modules: {},
  getters,
  plugins: [persistedState()],
});
